import { combineReducers } from "redux-immutable";

import TeacherAssignmentsState from "../../models/TeacherAssignmentsState";

import assignmentsReducer from "./assignments";
import teacherAssignmentsMetaReducer from "./meta";

export default combineReducers(
  {
    assignments: assignmentsReducer,
    meta: teacherAssignmentsMetaReducer
  },
  () => new TeacherAssignmentsState() as any
);
